<template>
	<table>
		<tr>
			<th colspan="2">
				<h2>{{ title }}</h2>
				<div class="buttons">
					<slot name="buttons"></slot>
				</div>
			</th>
		</tr>
		<slot></slot>
	</table>
</template>
<script>
	export default {
		name: 'RegisterTable',
		props: {
			title: {
				type: String,
				required: true,
			},
		},
	};
</script>
<style lang="scss" scoped>
	table {
		margin-bottom: 0.5em;
	}
	h2 {
		font-size: 1.5em;
		font-weight: bold;
	}

	tr,
	th,
	td {
		position: relative;
	}

	th {
		background: #f4f7fa;
		color: #657088;
		border-bottom: 1px solid #ebebed;
		padding: 1em;
	}

	.buttons {
		position: absolute;
		right: 1em;
		top: 50%;
		transform: translateY(-50%);
	}
</style>
